module.exports = __webpack_public_path__ + "static/img/about_Phone_IMG_Mobile.6b5ddfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mobile/Mobile_About_Us/about_Phone_IMG_Mobile.png
// module id = LQNV
// module chunks = 0